import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBettingRules } from "@/api/bettingRules";
import { BettingRulesQueryKeys } from "@/tanstackQuery/queries/bettingRules";

export const useDeleteBettingRules = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBettingRules,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BettingRulesQueryKeys.BettingRules],
      });
    },
  });
};
